import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { SnsTopic } from '@shared/models/sns-notification/sns-topic';

@Component({
  standalone: false,
  selector: 'app-notification-table',
  templateUrl: './notification-table.component.html',
  styleUrls: ['./notification-table.component.scss'],
})
export class NotificationTableComponent implements OnChanges {
  @Input()
  isLoading: boolean;

  currentLanguage: string;

  @Input()
  topics: SnsTopic[];

  @Output()
  detail = new EventEmitter<{ id: string; index: number }>();

  sortConfig = [{ prop: 'name', dir: 'asc' }];

  openDetails(id: string, index: number) {
    this.detail.emit({ id, index });
  }
  
  ngOnChanges(){
    this.currentLanguage = localStorage.getItem('language') || 'defaultLanguage';
  }
  
  protected readonly top = top;
}
